import { ReactElement } from 'react'

import { FileInput as MantineFileInput, FileInputProps } from '@mantine/core'
import styled from 'styled-components'

import { colors } from 'src/Helpers/constants.ts'

const StyledInput = styled(MantineFileInput)`
  position: relative;
  width: 100%;

  input {
    height: 41px;
    border: 1px solid ${colors.secondGray};
    color: ${colors.thirdBlue};
    --input-placeholder-color: ${colors.thirdBlue};

    &::placeholder {
      opacity: 0.5;
      font-size: 12px;
    }
  }

  label {
    position: absolute;
    top: -10px;
    left: 10px;
    z-index: 1;
    width: fit-content;
    background-color: white;
    padding: 0 5px;
    font-size: 12px;
    color: ${colors.thirdGray};
  }

  &[data-error] input {
    border-color: ${colors.red};
  }

  &[data-error] {
    .mantine-Select-wrapper {
      margin-bottom: 0px !important;
    }
  }

  .mantine-TextInput-error {
    position: absolute;
    bottom: -15px;
    font-size: 11px;
    text-align: left;
  }
`

export type InputProps<Multiple extends boolean = false> =
  FileInputProps<Multiple> & {
    error?: string
  }

export const FileInput = <Multiple extends boolean = false>(
  props: InputProps<Multiple>,
): ReactElement => (
  <StyledInput {...(props as unknown as FileInputProps<boolean>)} />
)
